import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import Cookies from 'js-cookie'
import {HashLink} from "react-router-hash-link"

import CustomDropdown from "../subcomponents/CustomDropdown";

import useToolsStore from '../../stores/ToolsStore';

import coinsList from '../../utils/coinsList.json';
import { RiDeleteBack2Line } from "react-icons/ri";
import { IoIosAddCircleOutline } from "react-icons/io";
import { RiDeleteBack2Fill } from "react-icons/ri";

import useSettingsStore from '../../stores/SettingsStore';
import useUserSettingStore from '../../stores/UserSettingsStore';
import  useUserStore  from '../../stores/UserStore'




const targetList = Object.values(coinsList).sort();

function MobileTradeForm(props) {
    const url = props.url;
    const details = props.details;
    const strat = props.strat;
    const stop_settings_list = props.stop_settings_list;
    const input_list = props.input_list;
    const exchanges_list = props.button_list
    const [targetMissing, setTargetMissing] = useState(false)
    const [inputs, setInputs] = useState({ targets: "" });
    const [targetEntries, setTargetEntries] = useState([{ target: "", amount: ""}]);
    const [stopSettings, setStopSettings] = useState({})
    const [filledInput, setFilledInput] = useState({})
    const [selectedAccordion, setSelectedAccordion] = useState("More Options")
    const [detailsAccordion, setDetailsAccordion] = useState(false)

    const {setMobileComponent, mobileComponent} = useToolsStore()
    const settings = useSettingsStore((state) => state.settings)
    const selectedSetting = useSettingsStore((state) => state.selectedSetting)
    const selectSetting = useSettingsStore((state) => state.selectSetting)
    const clearSelectedSettingStore = useSettingsStore((state) => state.clearSelectedSetting)
    const userTargets = useUserSettingStore((state) => state.targets)
    const fetchUserSettings = useUserSettingStore((state) => state.fecthUserSettings)


  const clickCounts = useRef({});

  const data_accordion = {"More Options": input_list, "Stop Settings": stop_settings_list}
  const accordion1 = {"More Options": input_list}
  const accordion2 = {"Stop Settings": stop_settings_list}

  useEffect(() => {
    var data = require('../forms/settings.json');

    const fetchData = async () => {
        try {
            
            await fetchUserSettings();
            if (!selectedSetting || selectedSetting === "undefined") {
                selectSetting("DEFAULT");
                return;
              }
              
        
            if (selectedSetting && Object.keys(selectedSetting).length !== 0) {
                setFilledInput(prevFilledInput => ({
                    ...prevFilledInput,
                    ...selectedSetting
                }));
                setStopSettings(prevStopSettings => ({
                    ...prevStopSettings,
                    ...selectedSetting.stop_settings
                }));
            } else {
                const input_list = data.settings_list || []; 
                setFilledInput(current => {
                    const updatedInput = { ...current };
                    input_list.forEach(inputKey => {
                        delete updatedInput[inputKey];
                    });
                    return updatedInput;
                });
                console.log('FILLED', filledInput)
                setStopSettings({});
            }
        } catch (error) {
            console.log("Error fetching user settings", error);
        }
    };

    fetchData();
}, [selectedSetting, fetchUserSettings]);

const toggleAccordion = (option) => {
  if (selectedAccordion === option) {
      
      return setSelectedAccordion(null)
      
  }
  
  setSelectedAccordion(option)
}
const toggleDetailsAccordion = () => {
  setDetailsAccordion(prevState => !prevState);
}

const handleStopChange = (event) => {
  const name = event.target.name 
  const value = event.target.value 
  setStopSettings((prevStopSettings) => ({
      ...prevStopSettings,
      [name]: value,
  }))
}

  // const handleChange = (e, index) => {
  //   const { name, value } = e.target;
  //   console.log('')
  //   if (name === 'target' || name === 'amount' ) {
  //     const values = [...targetEntries];
  //     values[index][name] = value;
  //     setTargetEntries(values);
  //     updateTargets(values);
  //   } else {
  //     setFilledInput((prevState) => ({
  //       ...prevState,
  //       [name]: value,
  //     }));
  //   }
  // };

  // const handleDropdownChange = (value, index) => {
  //   const values = [...targetEntries];
  //   values[index]['target'] = value;
  //   setTargetEntries(values);
  //   updateTargets(values);
  // };

  // const updateTargets = (values) => {
  //   const targetsString = values
  //     .filter(item => item.target && item.amount)
  //     .map(item => `${item.target}:${item.amount}`)
  //     .join('\n');
  //     setFilledInput(prevState => ({ ...prevState, targets: targetsString }));
  // };

  // const handleAddTarget = () => {
  //   setTargetEntries([...targetEntries, { target: "", amount: ""}]);
  // };

  // const handleRemoveTarget = (index) => {
  //   const values = [...targetEntries];
  //   values.splice(index, 1);
  //   setTargetEntries(values);
  //   updateTargets(values);
  // };


//   const getDivClass = (target) => {
//     const targetClicks = clickCounts.current[target] || 0;
//     console.log('Target ', targetClicks)
//     let className = "user_targets_container";
//     if (hasTarget(target)) {
//         if (targetClicks === 1) {
//             className += " checked_targets";
//         } else if (targetClicks === 2) {
//             className += " flipped_targets";
//         }
//     }

//         return className;
// }
// const hasTarget = (target) => {
//   const originalValues = target.split(' ').join(' ');
//   const flippedValues = target.split(' ').map(targ => {
//       const [symbol, value] = targ.split(':');
//       return `${symbol}:${-parseFloat(value)}`;
//   }).join(' ');

//   const targetsString = targetEntries.map(entry => `${entry.target}:${entry.amount}`).join(' ');
//   return targetsString && (targetsString.includes(originalValues) || targetsString.includes(flippedValues));
// }

const hasTarget = (target) => {
  const originalValues = target.split(' ').join(' ');
  const flippedValues = target.split(' ').map(targ => {
      const [symbol, value] = targ.split(':');
      return `${symbol}:${-parseFloat(value)}`;
  }).join(' ');

  return filledInput.targets && (filledInput.targets.includes(originalValues) || filledInput.targets.includes(flippedValues));
}

const getDivClass = (target) => {
  const targetClicks = clickCounts[target] || 0;
  
  // Base class
  let className = "user_targets_container no_drag";

  // If the target or its flipped version is in filledInput.targets
  if (hasTarget(target)) {
      if (targetClicks === 1) {
          className += " checked_targets no_drag";
      } else if (targetClicks === 2) {
          className += " flipped_targets no_drag";
      }
  }

      return className;
}
const handleTargets = (e) => {
  const targetValue = e.currentTarget.getAttribute('value');
  
  let targetClicks = clickCounts[targetValue] || 0;
 

  // if (filledInput.targets && !filledInput.targets.includes(targetValue)) {
  //     console.log('FILLED INPUT', filledInput.targets)
  //     console.log('FILLED INPUT', targetValue)
  //     targetClicks = 0;
  // }
  // const invertedTarget = invertTargets(targetValue)
  // if (filledInput.targets && !filledInput.targets.includes(invertedTarget)) {
  //     console.log('FILLED INPUT', invertedTarget)
  //     targetClicks = 0;
  // }
  targetClicks++;

  if (!filledInput.targets) {
      filledInput.targets = "";
  }

  const flippedTargets = targetValue.split(' ').map(targ => {
      const [symbol, value] = targ.split(':');
      return `${symbol}:${-parseFloat(value)}`;
  }).join(' ');
  const targetValuesArray = targetValue.split(' ');
  const flippedTargetsArray = flippedTargets.split(' ');


 

  if (targetClicks === 1) {
      const newTargets = filledInput.targets + " " + targetValue;
      setFilledInput(prevState => ({
          ...prevState,
          targets: newTargets.trim()
      }));
  } else if (targetClicks === 2) {
      const targetsArray = filledInput.targets.split(' ');

      // Replace each sub-target
      targetValuesArray.forEach((tv, idx) => {
          const position = targetsArray.indexOf(tv);
          if (position !== -1) {
              targetsArray[position] = flippedTargetsArray[idx];
          }
      });

      const updatedTargets = targetsArray.join(' ');

      setFilledInput(prevState => ({
          ...prevState,
          targets: updatedTargets
      }));
      console.log('FILLED', filledInput)
  } else if (targetClicks === 3) {
      const targetsArray = filledInput.targets.split(' ');

      // Filter out each sub-target
      const updatedTargetsArray = targetsArray.filter(item => !targetValuesArray.includes(item) && !flippedTargetsArray.includes(item));

      const updatedTargets = updatedTargetsArray.join(' ');

      setFilledInput(prevState => ({
          ...prevState,
          targets: updatedTargets
      }));
      targetClicks = 0;  
  }

  clickCounts[targetValue] = targetClicks;
}


const handleChange = (e) => {
  const { name, value, id, checked } = e.target;
   if (name === 'targets' && id === "textareaTargets") {
      setFilledInput(prevState => ({
          ...prevState,
          targets: value
      }));
  } else {
      setFilledInput((prevFilledInput) => ({
          ...prevFilledInput,
          [name]: value,
      }))
  }  
}

console.log("Filled input", filledInput)
const targetReworked = (e) => {
  const { name, value } = e.target;

  if (name === "targets") {
      const lines = value.split('\n');
      const formattedLines = lines.map(line => {
          const parts = line.split(':');
          if (parts.length === 2) {
              const target = parts[0];
              const num = parts[1]
              const number = num.replaceAll(',', '')
              const thousands = /\B(?=(\d{3})+(?!\d))/g;
              const subparts = number.toString().split(".");
              const integer = subparts[0]
              const decimal = subparts[1]
              const withSeparator = integer.replace(thousands, ",") + (decimal ? "." + decimal : "");
              return `${target}:${withSeparator}`;
          }
          return line;
      })      
    const formattedValue = formattedLines.join('\n');
  //   setFilledInput({ [name]: formattedValue });
    setFilledInput((prevFilledInput) => ({
      ...prevFilledInput,
      [name]: formattedValue,
  }))
    return;
  }
  setFilledInput((prevFilledInput) => ({
      ...prevFilledInput,
      [name]: value,
  }))
  // setFilledInput({ [name]: value });
}


  const clearSelectedSetting = () => {
    const input_list = [  "setting_name","max_order_size", "cancel_price_gap", "stop_max_order_size","price_limit_is_last_ex_price","fill_delay","depth_min","depth_max", "rdm_qty_range", "aggro_order_on","aggro_depth","aggro_order_delay","aggro_book_ratio","aggro_forced_if_no_fill_in", "stop_settings"]
    
    setFilledInput(current => {
        const updatedInput = { ...current };
        input_list.forEach(inputKey => {
          delete updatedInput[inputKey];
        });
        return updatedInput;
      });
      setStopSettings({})
      clearSelectedSettingStore()
  }

  const handleSubmit = (e, button) => {
    e.preventDefault();
    send_form(button)
  }

  const transformEntriesToString = (entries) => {
    const validEntries = entries.filter(entry => entry.target && entry.amount);
    const resultString = validEntries
      .map(entry => `${entry.target}:${entry.amount}`)
      .join('\n');
  
    return resultString;
  };
  const replaceSpacesWithNewlines = (str) => {
    return str.replace(/ /g, '\n').replace(/,/g, '')
    };
  const  send_form = async (button) => {
    var data = {}
    const newTargets = replaceSpacesWithNewlines(filledInput.targets ? filledInput.targets : "")
    Object.keys(filledInput).map(function(input) {
        return(
            data[input] = filledInput[input]
        )
    }) 
    data['targets'] = newTargets
    data['stop_settings'] = stopSettings
    data['button'] = button  
    console.log('INOUTS', data)
    console.log('INPUT', filledInput)
    // const isValid = validateForm(data);
    const isValid = true
    if (isValid) {
        const token = Cookies.get('token')
        try {
                const response = await axios({
                    headers: { Authorization: token },
                    method: "POST",
                    url : url,
                    data : data
                })
                if (response.status === 200) {
                  
                    
                }
            } catch (err) {
                if (err.response.status === 401){                
                    useUserStore.getState().logOut()    
                }              
            }
        
    } 
  }
  return (
    <div className='mobile_subcontainer'>
    
      <div className="mobile_input_container target_input">
        <h3>Buy or Sell</h3>
        {/* {targetEntries.map((entry, index) => (
            <div className="mobile_target_input_container" key={index}>
              
               <input className="mobile_taget_amount_input input" type="number" name="amount" placeholder="Enter Amount" value={entry.amount} onChange={(event) => handleChange(event, index)} style={{ marginRight: '1rem' }}/>
               <input className="mobile_taget_amount_input input" type="text" name="target" placeholder="Enter target" value={entry.target} onChange={(event) => handleChange(event, index)} /> */}
              {/* <CustomDropdown options={targetList} value={entry.target} onChange={(value) => handleDropdownChange(value, index)} placeholder="Enter or select coin"/> */}
                {/* <input className="input mobile_taget_amount_input" name="currency" type="text" value={entry.currency} onChange={(event) => handleChange(event, index)} placeholder="USDT" style={{ marginLeft: '1rem' }}/> */}
             
              {/* <button className="btn" onClick={() => handleRemoveTarget(index)} >
                <RiDeleteBack2Line className='remove_target_icon'/>
              </button>
            </div>
        ))} */}
        {/* <button onClick={handleAddTarget} className='btn add_target_btn'><IoIosAddCircleOutline className='add_target_icon'/></button> */}
        <textarea className={targetMissing ? 'textarea input_missing no_drag' : "textarea no_drag"} placeholder="BTCUSDT:5000 ETHUSDT:1000"  id='textareaTargets' name='targets' spellCheck="false" onChange={(e) => handleChange(e)} value={filledInput["targets"] || ''} onBlur={(e) => targetReworked(e)}  rows="8" cols="35" />
       <ul className="mobile_user_settings_ul">
       {!userTargets && userTargets.length === 0 || Object.keys(userTargets).length ===0 ? 
                    
                    <HashLink onClick={() => setMobileComponent("my_profile")} className="btn link form_hashlink" smooth>Add targets</HashLink>
               
                :null   
        }
        {userTargets.map((target, i) => 
            <div  className={getDivClass(target)} id={"targets_container_"+i} key={"target"+i} value={target} onClick={(e) => handleTargets(e)}>
            {target.split(' ').map((targ, index) => {
                const [symbol, value] = targ.split(':');
                const formattedValue = parseFloat(value).toLocaleString();
    
                return (
                    <p className="usertarget" key={targ+"_"+index}>
                        {`${symbol}: ${formattedValue}`}
                    </p>
                );
            })}
        </div>
        )}
          </ul>
      </div>

      <div className="mobile_input_container mobile_settings">
        <h3>Choose Settings</h3>
        <ul className="mobile_settings_list_container">
          {
            Object.keys(settings).map(function(setting) {
                return(
                <li className={selectedSetting &&  selectedSetting["setting_name"] === setting ? "li li_setting active_li_setting" : "li li_setting"}  key={setting}>
                    <p key={setting+"input"} className="setting_name" onClick={() => selectSetting(setting)}>{setting.replaceAll('_', ' ')}</p>
                
              </li>)
            })
        }  
        </ul>   
        <div className="accordion" id="trade_more_options">
            {Object.keys(accordion1).map(function(option, i) {
                return(
                    <div className='item' key={"item" +i}>
                        <div className="accordion_header">
                        <div className="title" key={"title" + i} onClick={() => toggleAccordion(option)}>
                            <h3 key={"h3" +i}>{option}</h3>
                           
                            <span key={"span" +i}>{selectedAccordion === option ? "-" : "+"}</span>
                        </div>
                        {selectedSetting && Object.keys(selectedSetting).length !== 0 ?
                            <div className='clear_selected_setting_container' onClick={() => clearSelectedSetting()} >
                                <h3>{selectedSetting && selectedSetting["setting_name"].replaceAll('_', ' ')} </h3>
                                <RiDeleteBack2Fill onClick={() => clearSelectedSetting()} className='inline_icon clear_selected_setting_icon' />
                            </div>
                            : null
                        }
                        </div>
                        
                        {data_accordion[option].map((item, j) => 
                        
                        <div key={"content1_trade" +j} className={selectedAccordion === option ? "content show" : "content"}>
                            <p className="accordion_p" key={"p" +j}>{item.replaceAll('_', ' ')}</p>
                            <input key={"input" +j} className="input" name={item} id={option} value={filledInput[item] || ''} onChange={(e) => handleChange(e)} type="text" />
                            {/* <div key={"icon" +j} className="info_icon" id={item} onMouseOver={(e) => showDetails(e)} onMouseLeave={(e) => hideDetails(e)}>ⓘ</div>
                            <div key={"detail" +j} name={item} id={item + "details"} className="input_details hide_details">{details[item]}</div> */}
                        </div>
                        )}
                    </div>
                )
            })}
        </div>
        <div className="accordion" id="trade_stop_settings">
            {Object.keys(accordion2).map(function(option, i) {
                return(
                    <div className='item' key={"item" +i}>
                        <div className="title" key={"title" + i} onClick={() => toggleAccordion(option)}>
                            <h3 key={"h3_" +i}>{option}</h3>
                            <span key={"span_" +i}>{selectedAccordion === option ? "-" : "+"}</span>
                        </div>
                        {data_accordion[option].map((item, j) => 
                        
                        <div key={"content2_trade" +j} className={selectedAccordion === option ? "content show" : "content"}>
                            <p className="accordion_p" key={"p" +j}>{item.replaceAll('_', ' ')}</p>
                            <input key={"input_" +j} className="input" name={item} id={option} value={stopSettings[item] || ''} onChange={(e) => handleStopChange(e)} type="text" />
                            {/* <div key={"icon" +j} className="info_icon" id={item +"_stop_"} onMouseOver={(e) => showDetails(e)} onMouseLeave={(e) => hideDetails(e)}>ⓘ</div>
                            <p key={"detail" +j} name={item} id={item + "_stop_details"} className="input_details hide_details">{details[item]}</p> */}
                            
                        </div>
                        )}
                    </div>
                )
            })}
        </div> 
      </div>
      <div className="settings_infos_accordion_container">
      <div className="accordion"  >
        <h3 onClick={() => toggleDetailsAccordion()}>Settings information <span>{detailsAccordion ? "-" : "+"}</span></h3>
      </div>
      <div className={detailsAccordion ? 'settings_infos_container show_infos' : "settings_infos_container"}>
            {Object.keys(details).map(function(setting) {
                switch(setting) {
                    case 'setting_name':
                        return null
                    default:
                        return <div className='setting_info_container' key={setting +"_details"}>
                   
                        <h4 className='setting'>{setting.replaceAll("_", " ")}</h4>
                        <p className='setting_info'>{details[setting]}</p>
                    </div>
                }
            })}
        </div>
      </div>
      {exchanges_list && exchanges_list !== "undefined" && exchanges_list.length > 0 ? 
        <div className="std_form_btn_container">
            {exchanges_list.map((button, i) => 
            <button className="btn std_form_btn" type="submit" key={i} value={button} onClick={(e) => handleSubmit(e, button)} >{button.replaceAll('_', ' ')}</button>
            )}
        </div> :
        <div className="std_form_btn_container">
            <button  onClick={() => setMobileComponent("my_profile")} className="btn std_form_btn">Add Exchanges</button>
        </div>       
      }
      
    </div>
  );
}

export default MobileTradeForm;
